import React from 'react';
import { Popover } from 'antd';
import './CustomPopover.css';

const CustomPopover = ({ 
  children, 
  content, 
  title, 
  placement = 'bottomRight',
  trigger = 'click',
  className = '',
  width="200px",
  
  ...props 
}) => {
  return (
    <Popover
      content={content}
      title={title}
      placement={placement}
      trigger={trigger}
      className={`custom-popover ${className}`}
      {...props}
    >
      {children}
    </Popover>
  );
};

export default CustomPopover;